// extracted by mini-css-extract-plugin
export default {"paymentSection":"C6-z","disabled":"D6-z"};